import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import type { StorageAllocationsForShipperParams } from 'src/apis/storage/types';
import { useStorageAllocationsForShipper } from 'src/apis/storage/use-storage-allocations-for-shipper';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useStorageAllocationsForShipperPageParams } from 'src/pages/storage/allocations/overview/use-page-params';

const Page = lazy(() => import('./page'));

export const StorageAllocationsForShippers: FC<{
  storageServiceRoot: Successful<StorageServiceRootRequest>;
}> = ({ storageServiceRoot }) => {
  const pageParams = useStorageAllocationsForShipperPageParams();

  const params = useMemo(() => {
    return {
      limit: pageParams.value.pageSize,
      offset: pageParams.value.start,
      offerName: pageParams.value.offerName,
      allocationBusinessId: pageParams.value.allocationBusinessId,
      ssoOrganisationId: pageParams.value.ssoOrganisationId.map(
        (sso) => sso.value
      ),
      storageLocationId: pageParams.value.storageLocationId.map(
        (location) => location.value
      ),
      runtimeStart: pageParams.value.runtimeStart,
      runtimeEnd: pageParams.value.runtimeEnd,
      sortBy: pageParams.value.sortBy,
      sortDirection: pageParams.value.sortDirection,
    } satisfies StorageAllocationsForShipperParams;
  }, [pageParams.value]);

  const storageAllocations = useStorageAllocationsForShipper({
    storageServiceRoot,
    params,
  });

  if (storageAllocations.response == null) return <PageSpinner />;

  return (
    <Page
      pageParams={pageParams}
      storageAllocations={storageAllocations}
      storageServiceRoot={storageServiceRoot}
    />
  );
};
